
export const userKey = 'auth_user'
export const baseApiUrl = 'https://641ysleggl.execute-api.us-east-2.amazonaws.com/dev/'

//API ANTIGA -> REMOVER ELA
export const baseApiUrl2 = 'https://api.visiolens.app/testing'

export default { baseApiUrl, baseApiUrl2, userKey }
